import { render, staticRenderFns } from "./NavigationModel.vue?vue&type=template&id=4ededef2&scoped=true&"
import script from "./NavigationModel.vue?vue&type=script&lang=js&"
export * from "./NavigationModel.vue?vue&type=script&lang=js&"
import style0 from "./NavigationModel.vue?vue&type=style&index=0&id=4ededef2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ededef2",
  null
  
)

export default component.exports